import { Icon, IconProps } from "@chakra-ui/react";

function AddImageIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.12">
        <path
          d="M6.53131 19.608L14.9902 11.9181C15.3488 11.5921 15.5281 11.4291 15.7327 11.3627C15.913 11.3041 16.1063 11.298 16.29 11.3451C16.4983 11.3985 16.6875 11.5499 17.066 11.8527L19.8632 14.0905C20.2413 14.393 20.4304 14.5442 20.5734 14.7264C20.7531 14.9554 20.8807 15.2208 20.9472 15.5041C21.0002 15.7296 21.0002 15.9717 21.0002 16.456C21.0002 17.8951 21.0002 18.6147 20.7584 19.1799C20.4549 19.8894 19.8896 20.4547 19.1801 20.7582C18.6149 21 17.8953 21 16.4561 21H7.06944C6.42644 21 6.10494 21 5.96334 20.8755C5.84061 20.7676 5.77835 20.6066 5.79659 20.4442C5.81763 20.2568 6.05552 20.0406 6.53131 19.608Z"
          fill="currentColor"
        />
        <path
          d="M8.50016 10.5C9.60473 10.5 10.5002 9.60457 10.5002 8.5C10.5002 7.39543 9.60473 6.5 8.50016 6.5C7.39559 6.5 6.50016 7.39543 6.50016 8.5C6.50016 9.60457 7.39559 10.5 8.50016 10.5Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default AddImageIcon;
